export enum RegisterStepTwoResponse {
  DEFAULT,
  RESEND,
}
